module.exports = __webpack_public_path__ + "img/fi-rr-gallery.4a2c62bb.svg";